@use "ui/styles/colors";
@use "ui/styles/sizes";
@use "ui/styles/effects";
@use "ui/styles/fonts";

.content {
    background: var(--background-color, colors.$white);
    border-radius: effects.$borderRadiusS;
    overflow: visible;
    box-shadow: 0px 4px 8px 0px effects.$shadowColor;
    border: 1px solid var(--border-color, colors.$gray20);
    z-index: 1000;
    // Animation properties for enter/exit
    animation-duration: 300ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

    &[data-state="open"] {
        animation-name: slideUpAndFade;
    }

    &[data-state="closed"] {
        animation-name: slideDownAndFade;
    }

    &[data-side="top"] {
        animation-name: slideDownAndFade;
    }

    &[data-side="right"] {
        animation-name: slideLeftAndFade;
    }

    &[data-side="bottom"] {
        animation-name: slideUpAndFade;
    }

    &[data-side="left"] {
        animation-name: slideRightAndFade;
    }
}

.arrow {
    fill: var(--background-color, colors.$white);
    filter: drop-shadow(0px -1px 2px rgba(0, 0, 0, 0.08));
}

.close {
    @include effects.iconButton;
}

// Animation keyframes
@keyframes slideUpAndFade {
    from {
        opacity: 0;
        transform: translateY(2px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideRightAndFade {
    from {
        opacity: 0;
        transform: translateX(-2px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes slideDownAndFade {
    from {
        opacity: 0;
        transform: translateY(-2px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideLeftAndFade {
    from {
        opacity: 0;
        transform: translateX(2px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}